import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Message } from 'primeng/api';
import { MessageService } from '@shared/services/message-service';
import { PieceRateService } from 'projects/warehousing/src/app/services/piece-rate.service';
import { Subscription } from 'rxjs';
import { PieceRateAdjustment } from '@shared/models/piece-rate-adjustment';
import { PieceRateActivity } from '@shared/models/piece-rate-activity';

@Component({
    selector: 'app-piece-rate-reset',
    templateUrl: './piece-rate-reset.component.html',
    styleUrls: ['./piece-rate-reset.component.scss']
})
export class PieceRateResetComponent implements OnInit, OnDestroy {
    _activity: PieceRateActivity;

    @Input() set activity(act: PieceRateActivity) {
        this._activity = act;
        this.setCurrentAdjTypeId();
    }
    get activity(): PieceRateActivity {
        return this._activity;
    }

    adjustment: PieceRateAdjustment;
    subscriptions: Subscription[];
    startupSubscription: Subscription;
    adjustmentId: number;
    pieceRateActivity: number;
    weekIsClosed: boolean = false;
    weekIsLocked: boolean = false;
    loadingIndicator: boolean = false;
    modalVisible: boolean = false;
    _pieceRateResetedMsg: Message;
    _pieceRateResetErrorMsg: Message;

    constructor(
        private messageService: MessageService,
        private pieceRateService: PieceRateService
    ) {}

    ngOnInit(): void {
        this.subscriptions = [
            this.pieceRateService.CurrentPieceRateAdjustment.subscribe(
                buildersPieceRateAdjustment => {
                this.adjustment = buildersPieceRateAdjustment;
                if (buildersPieceRateAdjustment) {
                    this.adjustmentId = buildersPieceRateAdjustment.id;
                    this.weekIsClosed = buildersPieceRateAdjustment.weekIsClosed;
                    this.weekIsLocked = buildersPieceRateAdjustment.weekIsLocked;
                }
                else {
                    this.adjustmentId = null;
                    this.weekIsClosed = true;
                    this.weekIsLocked = true;
                }

                this.setCurrentAdjTypeId();
                }
            )
        ];
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    pieceRateReset(): void {
        this.modalVisible = true;
    }

    cancelPieceRateResetDialog(): void {
        this.modalVisible = false;
    }

    doPieceRateReset(): void {
        this.loadingIndicator = true;
        this.pieceRateService
            .pieceRateReset(this.adjustmentId, this.pieceRateActivity)
            .subscribe(
                () => {
                    this._pieceRateResetedMsg = {
                        severity: 'success',
                        summary: this.activity.description + ' entries have been reset.',
                        detail: ''
                    };
                    this.messageService.add(this._pieceRateResetedMsg);
                    this.loadingIndicator = false;
                    this.modalVisible = false;
                },
                _error => {
                    this._pieceRateResetErrorMsg = {
                        severity: 'error',
                        summary: 'Error Reseting ' + this.activity.description + ' entries',
                        detail: 'If this error persists, please contact PLA support.'
                    };
                    this.messageService.add(this._pieceRateResetErrorMsg);
                    this.loadingIndicator = false;
                }
            );
    }

    setCurrentAdjTypeId(): void {
        const adjTypeId: number = this._activity.id;

        if (this.adjustment) {
            const entry = this.adjustment.activityConfigs.find(ae => ae.pieceRateActivity === adjTypeId);
            if (entry)
                this.pieceRateActivity = entry.pieceRateActivity;
        }
    }
}
